import { Box } from '@mui/material';

/** First stop for a keyboard: jumps past the navigation to the page itself. Hidden until focused. */
export function SkipLink() {
  return (
    <Box component="a" href="#main" sx={{
      position: 'fixed', top: 12, left: 12, zIndex: 'tooltip', px: 2, py: 1, borderRadius: 1, bgcolor: 'primary.main', color: 'primary.contrastText',
      typography: 'body2', fontWeight: 500, textDecoration: 'none', transform: 'translateY(-160%)', '&:focus-visible': { transform: 'none' },
    }}>Skip to content</Box>
  );
}
